import AnimatedIntegrationHub from "@/components/AnimatedIntegrationHub";

const ICON_STYLE = { bg: "oklch(0.95 0.004 75)", color: "oklch(0.38 0.012 70)" };

const IntegrationsSection = () => (
  <section
    aria-labelledby="integrations-heading"
    className="relative w-full overflow-hidden border-y border-white/8 bg-[#0B0B0B] py-20 lg:py-24"
  >
    <div
      data-testid="integrations-dark-grid"
      className="absolute inset-0 pointer-events-none"
      aria-hidden="true"
      style={{
        backgroundImage: "radial-gradient(circle, rgba(255,255,255,0.18) 1.2px, transparent 1.2px)",
        backgroundSize: "22px 22px",
        maskImage: "radial-gradient(ellipse at center, black 30%, transparent 75%)",
        WebkitMaskImage: "radial-gradient(ellipse at center, black 30%, transparent 75%)",
      }}
    />
    <div
      data-testid="integrations-ambient-glow"
      className="absolute top-0 left-1/2 h-[300px] -translate-x-1/2 pointer-events-none"
      style={{
        width: "min(600px, calc(100vw - 2rem))",
        background: "radial-gradient(ellipse at top, oklch(var(--primary) / 0.12) 0%, transparent 70%)",
      }}
      aria-hidden="true"
    />

    <div className="relative max-w-5xl mx-auto px-6">
      <div className="mb-12 text-center">
        <p className="text-xs font-medium tracking-[0.2em] uppercase mb-3 text-[oklch(var(--primary-bright-readable))]">
          Integrations
        </p>
        <h2 id="integrations-heading" className="font-serif text-[2.1rem] text-white leading-tight mb-4">
          Connect your existing stack
        </h2>
        <p className="text-[15px] text-white font-light leading-relaxed max-w-[540px] mx-auto">
          You do not need to migrate or clean up your stack before Lumient becomes useful. Connect documents,
          spreadsheets, CRMs, billing systems, databases, and file stores as they already exist.
        </p>
      </div>

      <AnimatedIntegrationHub iconStyle={ICON_STYLE} />
    </div>
  </section>
);

export default IntegrationsSection;
